import { createSlice } from "@reduxjs/toolkit";

export const employeeSlice = createSlice({
  name: "employeeSlice",
  initialState: {
    employee: null,
  },
  reducers: {
    setEmployee: (currentSlice, action) => {
      currentSlice.employee = action.payload;
    },
  },
});

export const { setEmployee } = employeeSlice.actions;
export const employeeReducer = employeeSlice.reducer;
